module.exports = __webpack_public_path__ + "img/pdp.864d9712.webp";